import $ from "jquery";

export default class Breadcrumbs {
  constructor(labels = null) {
    if (labels) {
      this._loadFromLabels(labels);
    }
  }

  _loadFromDom() {
    if (!this._breadcrumbs) {
      const labels = $(".js-breadcrumbs .js-breadcrumb-label")
        .toArray()
        .map((element) => $(element).text().trim());
      this._loadFromLabels(labels);
    }
  }

  _loadFromLabels(labels) {
    this._breadcrumbs = Breadcrumb.fromLabels(labels);
  }

  list() {
    this._loadFromDom();
    return this._breadcrumbs;
  }

  labels() {
    return this.list().map((breadcrumb) => breadcrumb.label);
  }

  asString() {
    return this.labels().join(" > ");
  }
}

class Breadcrumb {
  static fromLabels(labels) {
    return labels.map((label) => (label == "Home" ? null : new Breadcrumb(label))).filter((e) => e);
  }

  constructor(label) {
    this.label = label;
  }
}
